// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-D":"D_shp2-detail-D__QxsnO"};